import { render, staticRenderFns } from "./AndOR.vue?vue&type=template&id=198563e5&"
import script from "./AndOR.vue?vue&type=script&lang=js&"
export * from "./AndOR.vue?vue&type=script&lang=js&"
import style0 from "./AndOR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports